import { MdDashboard } from 'react-icons/md'
import { VscRequestChanges } from 'react-icons/vsc'
import { FiLogOut } from 'react-icons/fi'
import { TbExchange } from 'react-icons/tb'

export const SidebarData = [
  {
    title: 'Dashboard',
    icon: <MdDashboard />,
    link: '/admindashboard',
  },
  {
    title: 'Requests',
    icon: <VscRequestChanges />,
    link: '/billhistory',
  },
  // {
  //   title: 'Rejected Requests',
  //   icon: <MdOutlineCancelScheduleSend />,
  //   link: '/rejectedRequests',
  // },
  {
    title: 'Switch Portal',
    icon: <TbExchange />,
    link: '/portal',
  },
  {
    title: 'Logout',
    icon: <FiLogOut />,
    link: '',
  },
]
